import { PlayerContractYearStats } from 'types/contracts';
import { RootState } from 'store';

export const selectContractsIsLoading = (state: RootState): boolean => state.contracts.isLoading;

export const selectContracts = (state: RootState): PlayerContractYearStats => state.contracts.contracts;
